import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PlaybookCommunicationService } from '../../services/playbook-communication.service';
import { CommonHttpService } from 'src/app/shared/services/common-http/common-http.service';
import { Playbook } from 'src/app/shared/model/playbook.models';
import { cloneDeep } from 'lodash';
import { PlaybookManifest } from 'src/app/shared/model/container.models';

@Component({
    selector: 'app-playbook-custom-css',
    templateUrl: './playbook-custom-css.component.html',
    styleUrls: ['./playbook-custom-css.component.scss'],
    standalone: false
})
export class PlaybookCustomCssComponent implements OnInit {

  playbook: Playbook;
  private playbookCustomCssConst: any;
  constructor(
    private modalRef: BsModalRef,
    private commService: PlaybookCommunicationService,
    private commonHttpService: CommonHttpService
  ) { }

  ngOnInit() {
    // to set playbook when opened from container component
    if (!this.playbook) {
      this.playbook = this.commService.Playbook;
    }
    this.playbookCustomCssConst = cloneDeep(this.playbook.customCss);
  }

  /**
   * To save custom playbook css
   */
  savePlaybookCss() {
    if (!this.playbook.enableCustomFonts) {
      this.playbook.customFonts = null;
      this.playbook.isEmbededFonts = false;
    }
    const reqObj = {
      id: this.playbook.id,
      isEmbededFonts: this.playbook.isEmbededFonts,
      customCss: this.playbook.customCss,
      enableCustomFonts: this.playbook.enableCustomFonts,
      customFonts: this.playbook.customFonts
    };
    this.commonHttpService.put({
      uri: '/api/Playbooks/UpdatePlaybookSettings',
      object: reqObj
    }).subscribe(response => {
      // fetching updated manifest to apply new css
      this.commService.setPlaybookManifest(PlaybookManifest.CUSTOM_CSS);
      this.closeModal(true);
    });
  }

  /**
   * To close the modal
   */
  closeModal(isSaved?) {
    this.modalRef.hide();
  }

  setplaybookCustomCss(event) {
    this.commService.setplaybookCustomCss(event);
  }
}
